import React from "react";

const REVIEWS = [
  {
    initials: "KS",
    name: "Katja Schreiber",
    location: "Düsseldorf",
    text: "Endlich eine Plattform, die wirklich funktioniert! Ich habe meine Wohnung hier inseriert und innerhalb von zwei Wochen den perfekten Mieter gefunden. Einfach, schnell und unkompliziert.",
  },
  {
    initials: "TM",
    name: "Theo Müller",
    location: "Berlin",
    text: "Die Suchfunktion ist super intuitiv. Habe genau nach meinen Kriterien gefiltert und sofort passende Angebote gefunden – besser als alle anderen Portale, die ich bisher genutzt habe.",
  },
  {
    initials: "SK",
    name: "Sandra Koch",
    location: "München",
    text: "Wir haben unser Haus über Immointerest verkauft. Der Prozess war transparent, die Anfragen kamen schnell und der Verkauf verlief absolut reibungslos. Sehr empfehlenswert!",
  },
  {
    initials: "MB",
    name: "Markus Bauer",
    location: "Hamburg",
    text: "Der Suchauftrag war ein Gamechanger. Ich wurde direkt benachrichtigt, sobald ein passendes Objekt eingestellt wurde – so habe ich meine Traumwohnung noch vor der breiten Veröffentlichung gesichert.",
  },
  {
    initials: "JW",
    name: "Julia Wagner",
    location: "Frankfurt",
    text: "Die kostenlose Immobilienbewertung hat mir enorm geholfen, einen realistischen Verkaufspreis festzulegen. Die Einschätzung war fundiert und kam innerhalb eines Tages.",
  },
  {
    initials: "TR",
    name: "Thomas Richter",
    location: "Stuttgart",
    text: "Dank der Maklerempfehlung habe ich einen kompetenten Ansprechpartner vor Ort gefunden. Professioneller Service von Anfang bis Ende – ich kann Immointerest nur weiterempfehlen.",
  },
];

export const Feedback = () => {
  return (
    <div className="px-5 md:px-16 pb-10">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 max-w-6xl mx-auto">
        {REVIEWS.map((review) => (
          <div
            key={review.name}
            className="bg-lightGreen px-7 py-8 flex flex-col gap-5 hover:bg-[#FFD9C0] transition-colors duration-200"
          >
            <p className="text-[15px] text-primary font-helvetica font-light leading-relaxed flex-1">
              „{review.text}"
            </p>
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 rounded-full bg-primary flex items-center justify-center shrink-0">
                <span className="text-white text-xs font-semibold font-helvetica tracking-wide">
                  {review.initials}
                </span>
              </div>
              <div>
                <p className="text-primary font-semibold font-helvetica text-sm leading-tight">{review.name}</p>
                <p className="text-gray font-helvetica font-light text-xs mt-0.5">{review.location}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
